import { useSetRecoilState } from "recoil";

import { IRideDto, ridePreviousMetadataSnapshotAtom } from "@ryde/shared";

export const useRideMetadataSnapshot = () => {
  const setRidePreviousMetadataSnapshot = useSetRecoilState(
    ridePreviousMetadataSnapshotAtom,
  );

  const updateRidePreviousMetadataSnapshot = (
    rideDto: Partial<IRideDto> | undefined,
  ): void => {
    const metadataSnapshot = rideDto?.metadata;
    if (metadataSnapshot) {
      setRidePreviousMetadataSnapshot(metadataSnapshot);
    }
  };

  const resetRidePreviousMetadataSnapshot = (): void => {
    setRidePreviousMetadataSnapshot(null);
  };

  return {
    updateRidePreviousMetadataSnapshot,
    resetRidePreviousMetadataSnapshot,
  };
};
